function ImageCaption(image) {
	/* THIS FIX */
	var _this = this;

	/* PRIVATE CONSTANTS */

	/* PRIVATE VARIABLES */
	

	/* PUBLIC PROPERTIES */
	this.image = null;
	this.inited = false;


	/* PRIVATE FUNCTIONS */
	function _construct() {
		_this.image = image;
		_this.init();
	}
	
	
	function wrapImageWithCaption(){
		// copy image classes
		var classes = _this.image.attr('class');
		_this.image.removeClass();
		
		// create caption
		var text = _this.image.attr('alt');
		var caption = $('<figcaption>');
		caption.text(text);
		
		// create container
		var fig = $('<figure>');
		fig.append(caption);
		fig.addClass(classes);
		
		// add container after image
		_this.image.after(fig);
		
		// move image into container, 
		caption.before(_this.image);
	}


	/* PUBLIC FUNCTIONS */
	this.init = function () {
		if (!_this.inited) {
			// init
			wrapImageWithCaption();

			_this.inited = true;
		}
	};


	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
